var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('table', {
    staticClass: "table table-sm"
  }, [_vm._m(0), _c('tbody', _vm._l(_vm.projectInfo, function (item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(item['Project Name']))]), _c('td', [_vm._v(_vm._s(item['Sub Project']))]), _c('td', [_vm._v(_vm._s(item.Location))]), _c('td', [item.Status === 'Active' ? _c('span', {
      staticClass: "badge badge-success"
    }, [_vm._v(" Active ")]) : _c('span', {
      staticClass: "badge badge-secondary"
    }, [_vm._v(" Inactive ")])])]);
  }), 0)])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('thead', {
    staticClass: "thead-light"
  }, [_c('tr', [_c('th', [_vm._v("Project Name")]), _c('th', [_vm._v("Sub Project")]), _c('th', [_vm._v("Location")]), _c('th', [_vm._v("Status")])])]);

}]

export { render, staticRenderFns }